import React from 'react';

type PDFViewerProps = {
  src: PDFViewerState;
};

type PDFViewerState = {
    url: string;
    query: string;
};

export default class PDFViewer extends React.Component<PDFViewerProps> {
  private viewerRef: React.RefObject<HTMLDivElement>;
  private src: PDFViewerState;
  constructor(props: PDFViewerProps) {
    super(props);
    this.src = this.props.src;
    this.viewerRef = React.createRef();
  }

  componentDidMount() {
    const element = this.viewerRef.current;
    let query = this.src.query;
    if (query.length > 6) {
      // Handle for AND and OR operators
      query = query.replaceAll(' AND ', '|').replaceAll(' OR ', '|');

      // Handle for NOT operator
      const notIndex = query.indexOf(' NOT ');
      query = notIndex === -1 ? query : query.substring(0, notIndex);

      // Replace quotes, prefix search operator, and parentheses
      query = query.replaceAll(/([()*"])/g, '');
    }

    const iframe = document.createElement('iframe');
    iframe.src = `/pdfjs-2.15.349-legacy-dist/web/viewer.html?file=${ encodeURIComponent(this.src.url) }&search=${ encodeURIComponent(query)}`;
    iframe.width = '100%';
    iframe.height = '100%';
    element?.appendChild(iframe);
  }

  render() {
    return (
      <div ref={this.viewerRef} id='viewer' style={{ width: '100%', height: '100%' }}>
      </div>
    )
  }

}